import { useEffect, useState } from 'react';
import { API_VARIALBE_FIELD } from '../../../Domain/Redux/Paths';
import { HttpClient } from '../../../Domain/Utils/ApiUtilies/Fetch/Fetch';
import { useGetIdLanguage } from '../HookLanguageSelector/useGetIdLnaguage';
import { COMPONENTS } from '../../../Domain/Settings/Constants/ComponentsParameter/ComponentsParameter';
import { ID_SYSTEM_INFORMATION } from '../../../Domain/Settings/Constants/Constants';

export const useGetVariableField = (service) => {
  const language = useGetIdLanguage();
  const [variables, setVariables] = useState([]);

  const fetchVariables = async () => {
    try {
      const data = await HttpClient.GET(API_VARIALBE_FIELD, {
        multilanguage_id: language,
        component: COMPONENTS.VARIABLE,
        service_code: service.code,
        service_id: service.id,
        system: ID_SYSTEM_INFORMATION.PORTAL
      });

      if (data.content) {
        setVariables(data.content);
      }
    } catch (error) {}
  };

  useEffect(() => {
    if (!language) return;
    fetchVariables();
  }, [service, language]);

  return { variables };
};
